import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";

const CustomFinancePostalCodeSelect = ({ postalCodeList, name, value, handlePostalCodeChange, apiLoading }) => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]); // Store filtered data
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const pageSize = 50;

    useEffect(() => {
        if (postalCodeList?.length) {
            setData(postalCodeList.slice(0, pageSize));
            setFilteredData(postalCodeList);
        }
        else {
            setData([]);
            setFilteredData([]);
        }
    }, [postalCodeList]);

    const handleScroll = (event) => {
        const { target } = event;
        if (target.scrollTop + target.clientHeight >= target.scrollHeight - 20) {
            loadMore();
        }
    };

    const loadMore = () => {
        if (loading || page * pageSize >= filteredData.length) return;

        setLoading(true);
        setTimeout(() => {
            setData((prev) => [
                ...prev,
                ...filteredData.slice(page * pageSize, (page + 1) * pageSize),
            ]);
            setPage((prev) => prev + 1);
            setLoading(false);
        }, 500);
    };

    const handleSearch = (value) => {
        if (!value) {
            setFilteredData(postalCodeList);
            setData(postalCodeList.slice(0, pageSize));
            setPage(1);
            return;
        }

        const filtered = postalCodeList.filter((postalCode) =>
            postalCode.toLowerCase().includes(value.toLowerCase())
        );

        setFilteredData(filtered);
        setData(filtered.slice(0, pageSize));
        setPage(1);
    };

    return (
        <Select
            name={name}
            disabled={apiLoading}
            className="finace-ant-select-form w-100"
            placeholder="Select Postal Code"
            showSearch
            onChange={(e) => handlePostalCodeChange(name, e)}
            value={value || undefined}
            onSearch={handleSearch}
            filterOption={false}
            onPopupScroll={handleScroll}
            options={data.map((postalCode) => ({ label: postalCode, value: postalCode }))}
            dropdownRender={(menu) => (
                <>
                    {menu}
                    {loading && <Spin style={{ display: "block", textAlign: "center", padding: "10px" }} />}
                </>
            )}
        />
    );
};

export default CustomFinancePostalCodeSelect;